const s = "styles-module__overlay___pahwI", o = "styles-module__show___UDXM2", e = {
  overlay: s,
  show: o
};
export {
  e as default,
  s as overlay,
  o as show
};
